export enum UsableCrudViewFormItemType {
  AssetPicker = 'asset-picker',
  Button = 'button',
  CheckBox = 'checkbox',
  CheckboxList = 'checkbox-list',
  CheckboxTable = 'checkbox-table',
  ColorPicker = 'color-picker',
  DatePicker = 'date-picker',
  DateTimePicker = 'datetime-picker',
  DimensionSelect = 'dimension-select',
  DocumentUpload = 'document-upload',
  HTMLEditor = 'html-editor',
  IconGalleryPicker = 'icon-picker-two',
  IconPicker = 'icon-picker-two-wrapper',
  ImageUpload = 'image-upload',
  InlineRowForm = 'inline-row-form',
  InputGroup = 'input-group',
  InputTemplate = 'input-template',
  MarkDown = 'markdown',
  MonacoCodeEditor = 'monaco-code-editor',
  Number = 'number',
  PhoneNumber = 'phone-number-input',
  Radio = 'radio',
  RadioGroup = 'radio-group',
  Rate = 'rate',
  RichTextEditor = 'rich-text-editor',
  Select = 'select',
  Slider = 'slider',
  StringArray = 'string-array',
  Switch = 'switch',
  TextArea = 'textarea',
  TextBox = 'textbox',
  TimePicker = 'time-picker'
}
